<div class="input-group" id="phone-input-group">
  <div class="btn-group" dropdown #dropdown="bs-dropdown" [autoClose]="false" (click)="getRegisterCountryCode()" >
    <button dropdownToggle type="button" class="btn dropdown-toggle" data-toggle="dropdown" (click)="changeRegisterCountryCode()" >
      <img src="{{imageUrl}}" alt="" width="20" height="20">
      <img src="assets/img/common/caret-arrow-down-icon.png" alt="" class="st-icon">
    </button>
    <!-- <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">   
      <a class="dropdown-item" *ngFor="let registerCountryCodeobj of registerCountryCode; let i = index;" [class.active]="selectedIndex == i" [class.disabled]="isDisabled" (click)="selectedRegisterCountryCode(i,dropdown.isOpen = !dropdown.isOpen)">
        <li role="menuitem">
          <img src="{{registerCountryCodeobj.imageUrl}}" alt="" width="25" height="25"> 
          <span style="position: relative; top: -8px; left: 5px;">
            {{ registerCountryCodeobj.prefix }}
            {{ registerCountryCodeobj.countryName }}
          </span>  
        </li>
      </a>
    </ul> -->

    <ul *dropdownMenu class="dropdown-menu">
      <li class="dropdown-item"
          *ngFor="let item of registerCountryCode; let i = index"
          [class.active]="selectedIndex === i"
          (click)="selectedRegisterCountryCode(i, dropdown)">
        <img [src]="item.imageUrl" width="25" height="25">
        {{ item.prefix }} {{ item.countryName }}
      </li>
    </ul>

  </div> 
  <input type="tel" class="form-control" (keyup.enter)="enter($event)" (keypress)="space($event)" (focusout)="checkPhoneNumber()" (keyup)="checkPhoneNumber()" id="loginPhone" class="auth-input" placeholder="{{ 'phoneNumberHint' | translate }}" [(ngModel)]="phoneValue" [ngModelOptions]="{standalone: true}"/>
  <img src="assets/img/common/correct.png" class="auth-valid" alt="" style="display: none;">
</div>

<!-- <div class="input-group" id="phone-input-group">

  <div class="btn-group"
       dropdown
       #dropdown="bs-dropdown">

    <button dropdownToggle
            type="button"
            class="btn dropdown-toggle">
      <img [src]="imageUrl" width="20" height="20">
      <img src="assets/img/common/caret-arrow-down-icon.png" class="st-icon">
    </button>

    <ul *dropdownMenu class="dropdown-menu">
      <li class="dropdown-item"
          *ngFor="let item of registerCountryCode; let i = index"
          [class.active]="selectedIndex === i"
          (click)="selectedRegisterCountryCode(i, dropdown)">
        <img [src]="item.imageUrl" width="25" height="25">
        {{ item.prefix }} {{ item.countryName }}
      </li>
    </ul>

  </div>

  <input type="tel"
         id="loginPhone"
         class="form-control auth-input"
         placeholder="{{ 'phoneNumberHint' | translate }}"
         [(ngModel)]="phoneValue"
         [ngModelOptions]="{ standalone: true }"
         (keyup.enter)="enter($event)"
         (keypress)="space($event)"
         (focusout)="checkPhoneNumber()"
         (keyup)="checkPhoneNumber()" />

</div> -->
